/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  HistoryTable.tsx
*
* Project Title : Checkout
*
* Description   : History Component
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H422336
*
* @Date         : Oct 23 2020
*
* @Version      : Version 1.0
*
* By            : H422336
* On            : Nov, 5 2020
* Description   : ASDS-4016 UI Enhancements for Phase-II
*
* By            : H422336
* On            : Nov, 17 2020
* Description   : ASDS-4074 Bugfix
*
******************************************************************************/

import * as React from 'react';
import { Grid, Icon } from '@scuf/common';
import '@scuf/common/honeywell/theme.css';
import '@scuf/styles/variables.scss';
import { DataTable } from '@scuf/datatable';
import { connect } from 'react-redux';
import OrderHistoryActions from '../redux/actions/order-history-actions';
import OrderFilter from './OrderFilter';
import { ICellData } from '@scuf/datatable/dist/components/DataTable/IDataTableInterfaces';
import GenericLoader from '../Loader/Loader';
import CheckoutConstants from '../constants/checkout-constants';

interface IOrdersProps {
    orders: IOrderHistoryData[];
    isProcessingRequest: boolean;
    isFetching: boolean;
    soldTos: any;
    filters: any;
    downloadInvoice: Function;
    updateFilters: Function;
    getOrderHistoryWithFilters: Function;
    getOrderHistory: Function;
}

interface IOrderHistoryData {
    orderDate: string;
    orderId: string;
    orderNo: string;
    orderStatus: string;
    orderedBy: string;
    products: any
}

class HistoryTable extends React.Component <IOrdersProps, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            filters: {
                status: '',
                soldTo: '',
                toDate: '',
                fromDate: '',
                reset: false
            }
        };

        this.setSelectedFilters = this.setSelectedFilters.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
    }

    setSelectedFilters() {
        this.setState({
            filters: this.props.filters
        });
    }

    applyFilters() {
        let data = this.props.orders.map(entry => {
           let productName = entry?.products.map(product => {
            if(product?.productName?.includes(CheckoutConstants.APU_AIRBUS_PRODUCT_NAME?.toUpperCase())) {
                return '131-9A Key'
            }
            else if(product?.productName?.includes(CheckoutConstants.APU_BOEING_PRODUCT_NAME?.toUpperCase())) {
                return '131-9B Key'
            }
            else if(product?.productName?.includes(CheckoutConstants.DLMUW_PRODUCT_NAME?.toUpperCase())) {
                return 'DLMU-W Services'
            }
            else if(product?.productName?.includes(CheckoutConstants.ASPIRE_PRODUCT_NAME?.toUpperCase())) {
                return 'Aspire 400 Services'
            }
            else if(product?.productName?.includes(CheckoutConstants.ANALYZER_SERVICE_CENTERS_PRODUCT_NAME?.toUpperCase())) {
                return 'Analyzer Services'
            }
            else if(product?.productName?.includes(CheckoutConstants.FAULT_ANALYZER_SERVICES_PRODUCT_NAME?.toUpperCase())) {
                return 'Fault Analyzer Services'
            }
            else if(product?.productName?.includes(CheckoutConstants.REMOTE_TERMINAL_SERVICES_PRODUCT_NAME?.toUpperCase())) {
                return 'Remote Terminal Services'
            }
            else {
                   return product?.productName
            }
           })
            const ordersWithProductName = {...entry,productName:productName};
           return Object.assign(ordersWithProductName)
        })


        const { filters } = this.state;

        if (filters.status !== '' || filters.soldTo !== '' || (filters.toDate !== '' && filters.fromDate !== '')) {
            this.props.getOrderHistoryWithFilters(
                filters.fromDate !== '' ? this.formatDateForFilter(filters.fromDate) : '',
                filters.toDate !== '' ? this.formatDateForFilter(filters.toDate) : '',
                filters.soldTo !== '' ? filters.soldTo : '',
                filters.status !== '' ? filters.status : ''
            );
        }

        if (filters.reset) {
            let soldToObj = this.props.soldTos.join(',');
            let filtersReset = {
                soldTo: '',
                status: '',
                fromDate: '',
                toDate: '',
                reset: false
            };
            this.props.updateFilters(filtersReset, 0);
            this.props.getOrderHistory(soldToObj);
        }
        return data;
    }

    formatDateForFilter(date) {
        let d = new Date(date),
            year = d.getFullYear(),
            month = d.getMonth() + 1,
            day = d.getDate();

        return year + '-' + month + '-' + day;
    }

    render() {
        const data = this.applyFilters();

        return (
            <Grid.Column width={12} className="order-history-table" >
            {this.props.isProcessingRequest && <GenericLoader text="Processing Request" className="order-history-loader" loading={true} overlayColor="rgb(247, 247, 247)" />}
                <Grid>
                    <Grid.Row className="fullwidthRow">
                        <DataTable
                            data={data}
                            search={true}
                            rows={10}
                            className={this.props.isFetching ? 'history-table loading' : 'history-table'}
                            searchPlaceholder="Search an order by Order Id"
                        >
                            <DataTable.HeaderBar>
                                <OrderFilter
                                    soldTos={this.props.soldTos}
                                    applyFilters={this.setSelectedFilters}
                                />
                            </DataTable.HeaderBar>

                            <DataTable.Column field="orderNo" header="order No." sortable={true} />
                            <DataTable.Column field="orderDate" header="Order Date" sortable={true} align="center" renderer={(cellData) => this.formatDate(cellData)} />
                            <DataTable.Column field="productName" header="product" sortable={true} align="center" renderer={(cellData) => this.renderProductName(cellData)} />
                            <DataTable.Column field="orderStatus" header="Status" sortable={true} align="center" renderer={(cellData) => this.getOrderStatus(cellData)} />

                            <DataTable.Column field="soldTo" header="Sold To No." sortable={true} align="center" />
                            <DataTable.Column field="totalQuantity" header="Item Qty." sortable={true} align="center"/>
                            <DataTable.Column field="totalPrice" header="Total Price" sortable={true} align="center" renderer={(cellData) => this.getTotalPrice(cellData)} />
                            <DataTable.Column field="invoiceDetail" header="Invoice" sortable={true} renderer={(cellData) => this.getInvoice(cellData)} />
                            <DataTable.Pagination
                                itemsPerPage={10}
                                totalItems={DataTable.length}
                                showDisplayDetails={true}
                                boundaryRange={7}
                            />
                        </DataTable>
                    </Grid.Row>
                </Grid>
            </Grid.Column>
        );
    }

    formatDate(cellData: ICellData) {
        let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        let date = new Date(cellData.rowData.orderDate),
            year = date.getFullYear(),
            month = date.getMonth(),
            day = date.getDate();

        return <span>{`${months[month]} ${day}, ${year}`}</span>;
    }

    getOrderStatus(cellData: ICellData) {
        if (cellData.rowData.orderStatus.toLowerCase() === 'inprogress') {
            return <span>In Progress</span>;
        } else if(cellData.rowData.orderStatus.toLowerCase() === 'completed') {
            return <span>Completed</span>;
        } else {
            return <span className="not-applicable-data">N/A</span>;
        }
    }

    getInvoice(cellData: ICellData) {
        if (cellData.rowData.orderStatus.toLowerCase() === 'completed' && (cellData.rowData.invoiceDetail && cellData.rowData.invoiceDetail.invoiceId)) {
            return (
                <div>
                    <span>{cellData.rowData.invoiceDetail.invoiceNo}</span>
                    <a onClick={() => this.props.downloadInvoice(cellData.rowData.invoiceDetail.invoiceNo, cellData.rowData.system)}>
                        <Icon className="file-download invoice-link" root="common" name="file-download" size="medium" />
                    </a>
                </div>
            );
        } else if (cellData.rowData.orderStatus.toLowerCase() === 'inprogress') {
            return <span className="not-applicable-data">In Progress</span>;
        } else if (!cellData.rowData.invoiceDetail || !cellData.rowData.invoiceDetail.invoiceId || !cellData.rowData.orderStatus) {
            return <span className="not-applicable-data">N/A</span>;
        } else {
            return <span className="not-applicable-data">N/A</span>;
        }
    }

    getTotalPrice(cellData: ICellData) {
        if (!cellData.rowData.orderStatus || !cellData.rowData.totalPrice) {
            return <span className="not-applicable-data">N/A</span>;
        } else {
            return <span>{`$${cellData.rowData.totalPrice}`}</span>;
        }
    }
    renderProductName(cellData: ICellData) {
            return cellData.rowData.productName.map(name => {
                 return (<div className='productName'>{name} </div>)
            })
    }
}

function mapStateToProps(state) {
    return {
        isProcessingRequest: state.orderHistoryData.isProcessingRequest,
        soldTos: state.orderHistoryData.soldTos,
        filters: state.orderHistoryData.filters,
        isFetching: state.orderHistoryData.payload.isFetching
    };
}

const mapDispatchToProps = {
    downloadInvoice: OrderHistoryActions.downloadOrderInvoice,
    updateFilters: OrderHistoryActions.updateFilters,
    getOrderHistory: OrderHistoryActions.getOrderHistory,
    getOrderHistoryWithFilters: OrderHistoryActions.getOrderHistoryWithFilters,
};

export default connect(mapStateToProps, mapDispatchToProps)(HistoryTable);
